var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import cloneDeep from 'lodash.clonedeep';
import { deserializeDate } from '../common';
import { nonenumerable } from '../annotations/nonenumerable';
export default class BaseModel {
    constructor(data = {}) {
        this._resource = ''; // to bv overriden, used by @Resource and RemoteSelect
        this.id = data.id;
        this.createdAt = deserializeDate(data.createdAt);
        this.updatedAt = deserializeDate(data.updatedAt);
        if (data.deletedAt) {
            this.deletedAt = deserializeDate(data.deletedAt);
        }
        if (data.version) {
            this.version = data.version;
        }
    }
    get exists() {
        return typeof this.id === 'string' && this.id.length > 0;
    }
    get clone() {
        return cloneDeep(this);
    }
    get json() {
        return JSON.parse(JSON.stringify(this));
    }
}
BaseModel.resource = ''; // to bv overriden, used by @Resource and RemoteSelect
__decorate([
    nonenumerable,
    __metadata("design:type", String)
], BaseModel.prototype, "_resource", void 0);
//# sourceMappingURL=base_model.js.map